<template>
    <div>
        <div v-if="step == 1">
            <h4 class="card-title">{{ $t('paper.order_paper') }}</h4>
            <p class="card-description">
                {{ $t('paper.order_ready_info') }}
            </p>

            <p class="card-description">
                {{ $t('paper.page_count_info') }}
            </p>

            <p class="card-description">{{ $t('paper.are_you_ready_then_continue_ordering') }}</p>

            <button
                class="btn btn-primary"
                @click="goToStep(2)">
                {{ $t('paper.start_order') }}
            </button>
            <a
                class="btn btn-primary float-right"
                :href="allorders"
                >{{ $t('paper.all_orders') }}</a
            >
        </div>
        <div v-if="step == 2">
            <h4 class="card-title">{{ $t('paper.retrieve_paper') }}</h4>
            <p class="card-description">
                {{ $t('paper.we_will_now_retrieve_your_paper_to_determine_the_number_of_pages') }}
            </p>
        </div>
        <div v-if="step == 3">
            <h4 class="card-title">{{ $t('paper.fill_in_data') }}</h4>
            <div class="row">
                <div class="col-md-7">
                    <label>{{ $t('common.street') }}</label>
                    <b-form-input
                        v-model="street"
                        :placeholder="$t('common.street')"></b-form-input>
                </div>
                <div class="col-md-5">
                    <label>{{ $t('common.house_number') }}</label>
                    <b-form-input
                        v-model="streetnumber"
                        :placeholder="$t('common.house_number')"></b-form-input>
                </div>
            </div>
            <div
                class="row"
                style="margin-top: 20px">
                <div class="col-md-5">
                    <label>{{ $t('common.postal_code') }}</label>
                    <b-form-input
                        v-model="zipcode"
                        :placeholder="$t('common.postal_code')"></b-form-input>
                </div>
                <div class="col-md-7">
                    <label>{{ $t('common.place') }}</label>
                    <b-form-input
                        v-model="city"
                        :placeholder="$t('common.place')"></b-form-input>
                </div>
            </div>
            <div
                class="row"
                style="margin-top: 20px">
                <div class="col-md-5">
                    <label>{{ $t('paper.amount') }}</label>
                    <b-form-select
                        v-model="quantity"
                        :options="quantityOptions"
                        @change="onQuantityChange"></b-form-select>
                </div>
                <div class="col-md-7">
                    <table class="table">
                        <tr>
                            <td>
                                <b>{{ $t('paper.price_by_piece') }}</b>
                            </td>
                            <td>&euro; {{ getPPP() }}</td>
                        </tr>
                        <tr>
                            <td>
                                <b>{{ $t('paper.price') }} {{ quantity }}x</b>
                            </td>
                            <td>&euro; {{ getExTax() }}</td>
                        </tr>
                        <tr>
                            <td><b>BTW (9%)</b></td>
                            <td>&euro; {{ getTax() }}</td>
                        </tr>
                        <tr style="border-top: 2px solid #000">
                            <td>
                                <b>{{ $t('paper.total') }}</b>
                            </td>
                            <td>&euro; {{ getTotal() }}</td>
                        </tr>
                    </table>
                </div>
            </div>

            <button
                class="btn btn-primary"
                @click="goToStep(4)">
                {{ $t('paper.go_further') }}
            </button>
        </div>
        <div v-if="step == 4">
            <h4 class="card-title">{{ $t('paper.checking_data') }}</h4>
            <div class="row">
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-12">
                            <label>{{ $t('common.street') }}</label
                            ><br />
                            {{ street }}
                        </div>
                    </div>
                    <div
                        class="row"
                        style="margin-top: 20px">
                        <div class="col-md-12">
                            <label>{{ $t('common.house_number') }}</label
                            ><br />
                            {{ streetnumber }}
                        </div>
                    </div>
                    <div
                        class="row"
                        style="margin-top: 20px">
                        <div class="col-md-12">
                            <label>{{ $t('common.postal_code') }}</label
                            ><br />
                            {{ zipcode }}
                        </div>
                    </div>
                    <div
                        class="row"
                        style="margin-top: 20px">
                        <div class="col-md-7">
                            <label>{{ $t('common.city') }}</label
                            ><br />
                            {{ city }}
                        </div>
                    </div>
                    <div
                        class="row"
                        style="margin-top: 20px">
                        <div class="col-md-5">
                            <label>{{ $t('paper.amount') }}</label>
                            {{ quantity }}
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <table class="table">
                        <tr>
                            <td>
                                <b>{{ $t('paper.price_by_piece') }}</b>
                            </td>
                            <td>&euro; {{ getPPP() }}</td>
                        </tr>
                        <tr>
                            <td>
                                <b>{{ $t('paper.price') }} {{ quantity }}x</b>
                            </td>
                            <td>&euro; {{ getExTax() }}</td>
                        </tr>
                        <tr>
                            <td><b>BTW (9%)</b></td>
                            <td>&euro; {{ getTax() }}</td>
                        </tr>
                        <tr style="border-top: 2px solid #000">
                            <td>
                                <b>{{ $t('paper.total') }}</b>
                            </td>
                            <td>&euro; {{ getTotal() }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <button
                class="btn btn-primary"
                @click="goToStep(3)"
                style="margin-top: 20px">
                {{ $t('paper.back') }}
            </button>
            <button
                class="btn btn-primary"
                @click="saveOrder()"
                style="margin-top: 20px">
                {{ $t('paper.make_payment') }}
            </button>
            <div v-if="step == 5">
                <h4 class="card-title">{{ $t('paper.document_is_empty') }}</h4>
                <p class="card-description">
                    {{
                        $t(
                            'paper.the_number_of_pages_is_zero_therefore_an_order_cannot_be_placed_please_contact_us_if_you_think_this_is_not_correct',
                        )
                    }}
                </p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'design-2021-paper-name-component',
    props: ['projectIn'],
    data() {
        return {
            allorders: this.routes.baseUrl() + '/account/orders',
            step: 1,
            project: this.projectIn,
            street: '',
            streetnumber: '',
            zipcode: '',
            city: '',
            quantity: 3,
            ppp: 0,
            extax: this.ppp != 0 ? this.quantity * this.ppp : 0,
            tax: this.extax * 0.09,
            total: this.extax + this.tax,
            quantityOptions: [
                { text: '1', value: 1 },
                { text: '2', value: 2 },
                { text: '3', value: 3 },
                { text: '4', value: 4 },
                { text: '5', value: 5 },
                { text: '6', value: 6 },
                { text: '7', value: 7 },
                { text: '8', value: 8 },
                { text: '9', value: 9 },
                { text: '10', value: 10 },
                { text: '15', value: 15 },
                { text: '20', value: 20 },
                { text: '25', value: 25 },
                { text: '30', value: 30 },
                { text: '35', value: 35 },
                { text: '40', value: 40 },
                { text: '45', value: 45 },
                { text: '50', value: 50 },
                { text: '75', value: 75 },
                { text: '100', value: 100 },
            ],
        };
    },
    methods: {
        getPPP() {
            return (this.ppp / 100).toFixed(2);
        },
        getExTax() {
            let exTax = this.ppp != 0 ? this.quantity * this.ppp : 0;
            exTax = exTax / 100;
            exTax = exTax.toFixed(2);
            return exTax;
        },
        getTax() {
            return ((this.quantity * this.ppp * 0.09) / 100).toFixed(2);
        },
        getTotal() {
            return ((this.quantity * this.ppp * 0.09 + this.quantity * this.ppp) / 100).toFixed(2);
        },
        goToStep(step) {
            if (step == 4) {
                if (this.street == '' || this.streetnumber == '' || this.zipcode == '' || this.city == '') {
                    //todo message
                    return;
                }
            }

            this.step = step;

            if (this.step == 2) {
                this.getNumberOfPages();
            }

            if (this.step == 3) {
                this.getPricePerPiece();
            }
        },
        getNumberOfPages() {
            this.alert.saving(
                this.$t('paper.retrieve_amount_of_pages'),
                this.$t('paper.the_number_of_pages_in_your_paper_is_now_determined'),
            );
            this.axios.get(this.routes.baseUrl() + '/paper/' + this.project.id + '/numpages').then(
                (response) => {
                    this.alert.close();
                    this.num_pages = response.data.numpages;

                    if (this.num_pages == 0) {
                        this.goToStep(5);
                    } else {
                        this.goToStep(3);
                    }
                },
                (error) => {
                    this.alert.close();
                    this.goToStep(5);
                },
            );
        },
        onQuantityChange() {
            this.getPricePerPiece();
        },
        getPricePerPiece() {
            this.axios
                .get(
                    this.routes.baseUrl() +
                        '/paper/' +
                        this.project.id +
                        '/priceperpiece/' +
                        this.num_pages +
                        '/' +
                        this.quantity,
                )
                .then(
                    (response) => {
                        this.ppp = parseInt(response.data.ppp);
                        this.quantity = parseInt(this.quantity);
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
        },
        saveOrder() {
            this.alert.saving();
            let data = {
                street: this.street,
                streetnumber: this.streetnumber,
                zipcode: this.zipcode,
                city: this.city,
                quantity: this.quantity,
                numpages: this.num_pages,
            };
            this.axios.post(this.routes.baseUrl() + '/paper/' + this.project.id + '/order', data).then(
                (response) => {
                    this.alert.close();
                    window.location.href = response.data.checkouturl;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped></style>
